import { render, staticRenderFns } from "./Lirun.vue?vue&type=template&id=f39216ee&scoped=true"
import script from "./Lirun.vue?vue&type=script&lang=js"
export * from "./Lirun.vue?vue&type=script&lang=js"
import style0 from "./Lirun.vue?vue&type=style&index=0&id=f39216ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39216ee",
  null
  
)

export default component.exports